module.exports = __webpack_public_path__ + "static/media/46f93a8c-c2f0-480b-b141-0ebeb178852e.234c0e84.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/46f93a8c-c2f0-480b-b141-0ebeb178852e.jpg
// module id = 815
// module chunks = 0